import lottie from 'lottie-web';
import thoughtLeadershipAnimation from '@/animations/bulb.json';

export function lottieThoughtLeadership() {
  return {
    init() {
      lottie.loadAnimation({
        container: this.$root,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: thoughtLeadershipAnimation
      })
    }
  };
}
